(function() {
    jQuery(document).ready(function () {
        window.avatarMenu = new cAvatar(".c-avatar-container");
        window.exploreButton = cExploreButton.init('.c-explore-button-container');
        window.mobileLeftMenu = new MobileLeftMenu(".c-mobile-left-menu");
        tmExploreMenuLoader.init();
        window.searchBoxDesktop = new cSearchBox(".s-header-search-wrapper .c-search-container");
        window.searchBoxMobile = new cSearchBox(".s-search-container-mobile .c-search-container");

        // Desktop, a site with a dropdown per destination: the search icon grows the box leftwards from its spot over the
        // dropdowns, which hide only once it is fully open; a click outside it or Escape shows them again and shrinks the
        // box back to the icon (header.scss .s-header--search-icon; Peter, COOL 728, 748)
        const searchIconHeader = document.querySelector(".s-header--search-icon");
        const searchIconButton = searchIconHeader?.querySelector(".header-search-link");
        if (searchIconButton) {
            const searchIconBox = searchIconHeader.querySelector(".s-header-search-wrapper");
            const searchIconRow = searchIconHeader.querySelector(".s-header-content");
            const searchIconLogo = searchIconHeader.querySelector(".s-header-left .c-logo-container");
            let searchIconOpen = false;
            // after the width transition, or at once when there is none (reduced motion)
            const afterGrow = (callback) => {
                if (parseFloat(getComputedStyle(searchIconBox).transitionDuration) > 0) {
                    let done = false;
                    const finish = (event) => {
                        if (done || (event && (event.target !== searchIconBox || event.propertyName !== "width"))) return;
                        done = true;
                        searchIconBox.removeEventListener("transitionend", finish);
                        callback();
                    };
                    searchIconBox.addEventListener("transitionend", finish);
                    setTimeout(finish, 400); // in case the transition never runs
                } else {
                    callback();
                }
            };
            const setSearchOpen = (open, focusIcon) => {
                if (open === searchIconOpen) return;
                searchIconOpen = open;
                searchIconButton.setAttribute("aria-expanded", open ? "true" : "false");
                if (open) {
                    // right edge on the icon's, as wide as 640px or the room after the logo and the row's 14px gap
                    const row = searchIconRow.getBoundingClientRect();
                    const icon = searchIconButton.getBoundingClientRect();
                    const left = searchIconLogo ? searchIconLogo.getBoundingClientRect().right + 14 : row.left;
                    searchIconHeader.style.setProperty("--tm-search-right", `${row.right - icon.right}px`);
                    searchIconHeader.style.setProperty("--tm-search-width", `${Math.min(640, icon.right - left)}px`);
                    searchIconHeader.classList.add("s-header--search-open");
                    void searchIconBox.offsetWidth; // start from the icon's size
                    searchIconHeader.classList.add("s-header--search-wide");
                    searchIconBox.querySelector(".c-search-value-container input")?.focus();
                    afterGrow(() => {
                        if (searchIconOpen) searchIconHeader.classList.add("s-header--search-full");
                    });
                } else {
                    searchIconHeader.classList.remove("s-header--search-full", "s-header--search-wide");
                    afterGrow(() => {
                        if (searchIconOpen) return;
                        searchIconHeader.classList.remove("s-header--search-open");
                        if (focusIcon) searchIconButton.focus(); // once the box is off it, or its ring shows at the box's end
                    });
                }
            };
            searchIconButton.addEventListener("click", (event) => {
                event.stopPropagation();
                setSearchOpen(true);
            });
            document.addEventListener("click", (event) => {
                if (searchIconOpen && !searchIconBox.contains(event.target)) setSearchOpen(false);
            });
            document.addEventListener("keydown", (event) => {
                if (event.key === "Escape" && searchIconOpen) {
                    setSearchOpen(false, true);
                }
            });
        }

        document.documentElement.style.setProperty('--scrollbar-width', `${getScrollbarWidth()}px`);

        if ( $(".s-search-container-mobile:not(.s-mobile-search-bar-hidden):visible").length > 0 ){
            $("body").addClass("has-search-mobile");
        }

        $(".c-close-header-section button").on("click", function(){
            $("body").removeClass("body-no-scroll");
            $("html").removeClass("html-modal-open");
        });

        $(".js-scrolls-widget-mobile").on("click", function(){
            if ( lastWindowState === 'small' && $("#v2BookingWidgetContainer").length ){
                $("html, body").animate({
                    scrollTop: ($("#v2BookingWidgetContainer").offset().top - 1 )
                }, 500);
            }
        });

        if ( $(".c-admin-logged-in-grid").length > 0 ){
            $(document).off("click", ".product-list .product-card:not(.carousel-product-card)");
            $(document).on("click", ".product-card.c-admin-logged-in-grid .product-card-body-top h3", function(e){
                e.preventDefault();
                const $h3 = $(this);

                if ( !$h3.find(".c-copy-admin-grid-product-title") ){
                    return true;
                }

                const $icon = $h3.find(".c-copy-admin-grid-product-title i");

                if ($icon.hasClass('fa-solid')) {
                    return;
                }            
            
                navigator.clipboard.writeText(
                    `Product: ` + $h3.text().trim() + ' [Dynamic] ' + '(' + $h3.find("a").data("tm-id") + ')'
                ).then(() => {

                    $icon.removeClass('fa-regular').addClass('fa-solid');
                    $icon.parent().append("<span>Copied!</span>");

                    setTimeout(function() {
                        $icon.removeClass('fa-solid').addClass('fa-regular');
                        $icon.parent().find('span').fadeOut(500, function() {
                            $(this).remove();
                        });
                    }, 500);                

                },() => {
                    /* Rejected - text failed to copy to the clipboard */
                });;                     
                
            });
        }

        $(document).on('focus', '.c-input-control input, .c-textarea-control textarea', function() {
            $(this).parents('.c-common-control').addClass('focused');
        });

        $(document).on('blur', '.c-input-control input, .c-textarea-control textarea', function() {
            $(this).parents('.c-common-control').removeClass('focused');
        });

        $(document).on('keyup change', '.c-input-control input, .c-textarea-control textarea', function() {
            if ($(this).val().length === 0) {
                $(this).parents('.c-common-control').addClass('empty');
            } else {
                $(this).parents('.c-common-control').removeClass('empty');
            }
        });

        if ( $("body.single-activity").length > 0 ) {
            const faqSummary = $('.faq-summary-answer');
            if ( $(faqSummary).length ){
                const faqSummaryAnswerText = $(faqSummary).find(".faq-summary-answer-text");
                const faqSummaryTextReadMore = $(faqSummary).find("a.c-mobile-only");
                const lineHeight = $(faqSummaryAnswerText).css("line-height").replace('px', '');
                const totalLines = $(faqSummaryAnswerText)[0].scrollHeight / lineHeight;
                const maxLines = $(faqSummaryAnswerText).data("max-lines-read-more-button") || 7;

                if (  totalLines > maxLines && $(window).width() > 1024) {
                    faqSummaryTextReadMore.removeClass('c-mobile-only');
                }
            }

            if ( $(".media-gallery").length > 0 ){
                window.activityDetailMainSlider = new cSlider(".media-gallery");
            }

            if ( $(".widget-area").length > 0 ){
                window.stickySidebar = new StickySidebar('.widget-area', {
                    topSpacing: 80,
                    bottomSpacing: 17,
                    containerSelector: '.element-container',
                    innerWrapperSelector: '.inner-wrapper-sticky',
                    minWidth: 1024,
                });
            }

            if ( $("#collapse-traveler-photos").length > 0 ){
                // delegated: the thumbnails arrive by AJAX (custom.js loadProductReviewPhotos())
                $("#collapse-traveler-photos").on("click", ".traveller__image__container", function( e ){
                    if ( typeof tmPhotoGallery !== 'undefined' && tmPhotoGallery !== null ){
                        tmPhotoGallery.showPhotoGalleryModal( 'traveler-photos', $(this).data('id') );
                    }
                });
            }

            if ( $(".c-traveler__slider").length > 0 && typeof $(".c-traveler__slider").comparisonTableSlickSlider === 'function' ){
                $(".c-traveler__slider").comparisonTableSlickSlider();
            }
        }

        if ( $(".c-hightlights-main-wrapper").length > 0 && typeof $(".c-hightlights-main-wrapper").highlightCardsSlickSlider === 'function' ){
            $(".c-hightlights-main-wrapper .c-scroll-content-pane").highlightCardsSlickSlider();
        }            


        if ( $('ul[data-total-items-ul]').length > 0 ){
            $('ul[data-total-items-ul]').each(function () {
                const $ul = $(this);
                const totalVisible = parseInt($ul.data('total-items-ul'), 10);
                const $items = $ul.find('li');

                if ($items.length > totalVisible) {
                    // Hide extra items
                    $items.slice(totalVisible).addClass('c-hidden');

                    // Create "See more" link
                    const hiddenCount = $items.length - totalVisible;
                    const $moreLink = $(`<a href="#" class="see-more-button no-color"><span>See ${hiddenCount} more</span>`);

                    $moreLink.insertAfter($ul);

                    // Handle click
                    $moreLink.on('click', function (e) {
                        e.preventDefault();
                        $ul.find('.c-hidden').removeClass('c-hidden');
                        $(this).remove();
                    });
                }
            });
        }

        $(".c-icon-bottom-values span[data-modal-target]").on("click", function (e) {
            e.stopPropagation();
        })

        // a tabbed modal's tabs (components/tabbed-modal: the Language / Currency popup, the shore-excursion route page's
        // Route / Ship popup): a tab shows its panel, #<tabs id>-tab-N inside .<tabs id>-tab
        $(".c-modal-header-wrapper > .c-tabs[id]").each(function () {
            var tabsId = this.id;
            if ( $("." + tabsId + "-tab").length === 0 ){
                return;
            }
            $(this).find(".c-tabs-item").on("click", function () {
                $(this).siblings(".c-tabs-item.c-tabs-item-active").removeClass("c-tabs-item-active");
                $(this).addClass("c-tabs-item-active");

                tab_id = '#' + tabsId + '-' + $(this).attr("data-tab-item-key");
                $("." + tabsId + "-tab .c-tab-navigation-content").addClass("c-hidden");
                $(tab_id).removeClass("c-hidden");
            });
        });

        $(document).on("click", ".suppress-activity-item a, .admin-links a", function (e) {
            e.stopPropagation();
        })

        $(document).on("click", ".tag-more-labels", function (e) {
            e.stopPropagation();
            $(this).siblings(".tag-label").removeClass("c-hidden");
            $(this).remove();
        })

    jQuery(document).on('viatorBookableItemSelectorChanged', function () {
        const $content = $('#viator-booking-wrapper-selected-info-description .read-more-content');

        if ( $content.text().length === 0 ){
            return;
        }

        const $wrapper = $content.parent();
        const lineHeight = parseFloat($content.css('line-height'));
        const lines = Math.round($content.parent().outerHeight() / lineHeight);
        $wrapper.find('.c-viator-read-more-link').remove();

        const shouldCollapse = lines > 4;

        $wrapper.toggleClass('show-only-2-lines', shouldCollapse);

        if (shouldCollapse) {
            $wrapper.append(`
                <a href="javascript:void(0)" class="c-viator-read-more-link">
                    <span>Read more</span>
                    <i class="far fa-chevron-down fa-xs" aria-hidden="true"></i>
                </a>
            `);
        }        
    });

        $(document).on("click", ".c-viator-read-more-link", function (e) {
            e.preventDefault();

            const $btn = $(this);
            const $wrapper = $("#viator-booking-wrapper-selected-info-description");

            const expanded = $btn.toggleClass("expanded").hasClass("expanded");

            $btn.find("span").text(expanded ? "Read less" : "Read more");

            $btn.find("i")
                .toggleClass("fa-chevron-up", expanded)
                .toggleClass("fa-chevron-down", !expanded);

            $wrapper.toggleClass("show-only-2-lines", !expanded);
        })

        // °F ⇄ °C on a weather pill (the old simple-weather markup; the Discover menu weather calls it from its card's switch,
        // mega-menu.js, with the pill and card as day). The first temperature decides the
        // direction; every .simple-weather__temp and [data-temp-f] in the pill flips and keeps its own suffix (°F/°C, a bare °, or none). data-temp-f, when present,
        // holds the exact °F so repeated flips never drift. instant = no fade (used right after the pill is inserted).
        window.tmFlipTemperature = function (day, instant) {
            const $temps = $(day).find(".simple-weather__temp, [data-temp-f]");
            if (!$temps.length) return;
            const toCelsius = $(day).find(".simple-weather__temp").first().text().trim().endsWith("F");
            const flip = function () {
                $temps.each(function () {
                    const $temp = $(this);
                    const text = $temp.text().trim();
                    const exactF = $temp.attr("data-temp-f");
                    const hasExactF = exactF !== undefined && exactF !== "" && !isNaN(Number(exactF));
                    const number = toCelsius && hasExactF ? Number(exactF) : parseFloat(text);
                    if (isNaN(number)) return;
                    const value = toCelsius
                        ? Math.round((number - 32) * 5 / 9)
                        : (hasExactF ? Number(exactF) : Math.round(number * 9 / 5 + 32));
                    let suffix = "";
                    if (text.endsWith("F") || text.endsWith("C")) {
                        suffix = toCelsius ? "°C" : "°F";
                    } else if (text.endsWith("°")) {
                        suffix = "°";
                    }
                    $temp.text(value + suffix);
                });
            };
            if (instant) {
                flip();
                return;
            }
            $temps.fadeOut(300).promise().done(function () {
                flip();
                $temps.fadeIn(300);
            });
        };
        // The visitor's unit on every pill (Peter, COOL 717): the saved pick (tmTemperature: theirs, or their account's), else
        // their country's (°F in the US, °C in Europe). A click on a pill saves the other unit, and every pill on the page
        // follows (tm_temperature_changed; the Discover menu's pills in mega-menu.js). A pill showing no unit is left as it is.
        const pillUnit = function (day) {
            const text = $(day).find(".simple-weather__temp").first().text().trim();
            return text.endsWith("F") ? "F" : (text.endsWith("C") ? "C" : "");
        };
        // mid-fade, the pill still shows its old unit: flipping it again would convert it twice
        const flipping = function (day) {
            return $(day).find(".simple-weather__temp").is(":animated");
        };
        const showUnit = function (unit, instant) {
            $(".simple-weather__day").not(".c-explore-weather .simple-weather__day").each(function () {
                const current = pillUnit(this);
                if (current !== "" && current !== unit && !flipping(this)) window.tmFlipTemperature(this, instant);
            });
        };
        $(document).on("click", ".simple-weather__day", function () {
            if ($(this).closest(".c-explore-weather").length) return; // the Discover menu pill opens its card instead
            if (flipping(this)) return;
            const current = pillUnit(this);
            if (window.tmTemperature && current !== "") {
                window.tmTemperature.setPreference(current === "F" ? "C" : "F");
            } else {
                window.tmFlipTemperature(this);
            }
        });
        $(document).on("tm_temperature_changed", function (e, data) {
            if (data && data.unit) showUnit(data.unit, false);
        });
        if (window.tmTemperature && typeof MutationObserver === "function" && $(".simple-weather, [class*=simple-weather]").length) {
            // the simple-weather plugin renders its pills after the page (Vue): each takes the unit as it appears;
            // a page without one asks nothing (no country lookup)
            // no country (a failed lookup): the default unit, as mega-menu.js's pills (COOL 805)
            (typeof tmVisitorStore === "object" ? tmVisitorStore.resolveCountry().catch(function () { return ""; }) : Promise.resolve("")).then(function (country) {
                const unit = window.tmTemperature.getEffectiveUnit(country);
                showUnit(unit, true);
                let pending = false;
                const observer = new MutationObserver(function () {
                    if (pending) return;
                    pending = true;
                    window.requestAnimationFrame(function () {
                        pending = false;
                        showUnit(window.tmTemperature.getEffectiveUnit(country), true);
                    });
                });
                observer.observe(document.body, { childList: true, subtree: true, characterData: true });
                window.setTimeout(function () { observer.disconnect(); }, 30000);
            });
        }
    });
})();

function getScrollbarWidth() {
  // Temporary div create karo
  const scrollDiv = document.createElement("div");

  // CSS apply karo to force scrollbar
  scrollDiv.style.width = "100px";
  scrollDiv.style.height = "100px";
  scrollDiv.style.overflow = "scroll"; // force scrollbars
  scrollDiv.style.position = "absolute";
  scrollDiv.style.top = "-9999px"; // hide it

  document.body.appendChild(scrollDiv);

  // offsetWidth - clientWidth = scrollbar width
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

  document.body.removeChild(scrollDiv);

  return scrollbarWidth;
}

const width = getScrollbarWidth();
